var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"font"},[_c('div',{staticClass:"cen"},[_vm._m(0),_c('div',[_c('span',[_vm._v("Copyright@ "+_vm._s(_vm.year)+" All rights reserved")])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"one"},[_c('span',{staticClass:"left"},[_vm._v("技术运营支持: 吉林省吉科软信息技术有限公司")])])
}]

export { render, staticRenderFns }